import { Link, type LinkProps, useParams } from 'react-router';
import { isLocale, DEFAULT_LOCALE, type Locale } from '@/strings/types';

interface LocaleLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

export default function LocaleLink({ to, ...rest }: LocaleLinkProps) {
  const params = useParams();
  const locale: Locale =
    params.locale && isLocale(params.locale) ? params.locale : DEFAULT_LOCALE;
  const normalized = to.startsWith('/') ? to : `/${to}`;
  const path = `/${locale}${normalized}`;
  return <Link to={path} {...rest} />;
}
